import React, { useState, useEffect } from 'react';
import './Searchresult1.css';
import Header from '../Header';
import { useNavigate, useParams } from "react-router-dom";
import Findreport from './Findreport';
import building from '../asset/图层 2 1.png';
import ok from '../asset/Check_fill.png';
import inner from '../asset/pexels-emrecan-2079246.png';
import outer from '../asset/pexels-tobiasbjorkli-2119713.png';
import Policy from '../Purchase/Policy';
import FetchFunc from '../API';

const PARTNER_BASE_PRICE = 199;

const Searchresult1 = () => {
    const navigate = useNavigate();
    // const location = useLocation();
    // const { query } = location.state || {};
    // const price = localStorage.getItem('price');
    const [condition,setCondition] = useState(false);
    const { id, partner } = useParams();
    const [address, setAddress] = useState('');
    const [price, setPrice] = useState('')
    const [type, setType] = useState('')
    const [finalPrice, setFinalPrice] = useState(null);
    const [googlePlaceId, setGooglePlaceId] = useState('');
    const [reportName, setReportName] = useState('');
    const [inspectionPrice, setInspectionPrice] = useState('');
    const [isUnavailable, setIsUnavailable] = useState(false);
    const isLoggedIn = localStorage.getItem('isLoggedIn') === "true";
    const role = localStorage.getItem('role');
    const hasReport = Boolean(reportName && reportName.trim() && price !== null && price !== undefined && price !== '');
    const displayedPrice = hasReport ? price : (role === 'Partner' ? PARTNER_BASE_PRICE : inspectionPrice);
    const hasDisplayPrice = displayedPrice !== null && displayedPrice !== undefined && displayedPrice !== '';
    const reportLabel = type?.toLowerCase() === 'apartment' ? 'Strata Report' : 'Building & Pest Report';
    const actionLabel = hasReport ? 'Purchase Report' : 'Book Inspector';
    const availabilityText = hasReport ? 'Report available now!' : 'Report to be arranged after payment';
    const etaText = hasReport ? 'ETA: Up to 30mins' : 'ETA: 2-4 Days';

    const handleSearch = () => {
        if (isUnavailable) {
            navigate('/contact');
            return;
        }
        if (!hasReport && !isLoggedIn) {
            navigate('/login');
            return;
        }
        localStorage.setItem('reportOK', hasReport);
        setCondition(true);
        setFinalPrice(price);
    };

    const handleConfirm = () => {
        setCondition(false);
        navigate('/purchasereport', {
            state: {
                address: hasReport ? address : undefined,
                query: hasReport ? undefined : address,
                price: displayedPrice,
                propertyId: id,
                googlePlaceId,
                purchaseFlow: hasReport ? 'EXISTING_REPORT' : 'NEW_REPORT',
            },
        });
    };

    const handleClose = () => {
        setCondition(false);
    };

    useEffect(() => {
        const fetchServices = async () => {
            try {
                setIsUnavailable(false);
                const response = await FetchFunc(
                    `/search/${id}`,
                    'GET',
                );
                // const response2 = await FetchFunc(
                //                     '/search/final-payment',
                //                     'GET',
                //                 );
                if (!response.ok) {
                    console.log(response.text());
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // if (!response2.ok) {
                //     console.log(response2.text());
                //     throw new Error(`HTTP error! Status: ${response2.status}`);
                // }
                const data = await response.json();
                if (!data || !data.propertyAddress) {
                    setIsUnavailable(true);
                    return;
                }
                // const data2 = await response2.json();
                // localStorage.setItem("final-payment", JSON.stringify(data2));
                if (partner) {
                    localStorage.setItem("partnerId", partner);
                }
                setAddress(data.propertyAddress);
                setPrice(data.reportPrice);
                setFinalPrice(data.reportFinalPrice);
                setType(data.type);
                setGooglePlaceId(data.googlePlaceId);
                setReportName(data.reportName || '');

                if (!data.reportName || !data.reportName.trim() || data.reportPrice === null || data.reportPrice === undefined) {
                    const inspectionResponse = await FetchFunc(
                        '/search/inspection',
                        'GET',
                    );
                    if (inspectionResponse.ok) {
                        const inspectionData = await inspectionResponse.json();
                        setInspectionPrice(inspectionData);
                    }
                }
            } catch (error) {
                console.error('Error fetching orders:', error);
                setIsUnavailable(true);
            }
        };
        fetchServices();
    }, [id, partner]);

    return (
        <div className='search_result1'>
            <Header />
            <div className='page_header'>
                <img src={building} alt='building' />
            </div>
            <div className='mobile_page_header'></div>
            <div className='purchase'>
                <div className='mobile_title'>
                    <h2>{reportLabel}</h2>
                </div>
                <div className='sell_price'>
                    {!isUnavailable && <h1>{hasDisplayPrice ? `$${displayedPrice}` : 'Price pending'}</h1>}
                    {!isUnavailable && <p>{etaText}</p>}
                    {hasReport && <p>Charge of ${finalPrice} for successful property buyers</p>}
                </div>
                <div className='details'>
                    <div className='title'>
                        <h2>{reportLabel}</h2>
                    </div>
                    {address && <h3>{address}</h3>}
                    {!address && <h3>{isUnavailable ? 'This report link has expired. Please contact us for an updated link.' : 'Report of this address is not available now, please contact us'}</h3>}
                    {!isUnavailable && <div className='available'>
                        <img src={ok} alt='ok' />
                        <p>{availabilityText}</p>
                    </div>}
                    <h4>Details</h4>
                    <p>SUPERIOR SERVICE, EXCEPTIONAL VALUE. <br />At QC Property Inspections, 
                    our skilled professionals provide comprehensive visual assessments to 
                    ensure the safety and structural integrity of your property. Backed by over 
                    a decade of industry expertise, we are committed to helping you make informed 
                    and confident choices for your current property or future investment.</p>
                    <div className="purchase_button">
                        <button onClick={handleSearch}>
                            {isUnavailable ? 'Contact Us' : actionLabel}
                        </button>
                    </div>
                </div>
            </div>
            {address && <div className="mobile_purchase_button">
                <button onClick={handleSearch}>
                    {actionLabel}
                </button>
            </div>}
            {!address && <div className="mobile_purchase_button">
                <button onClick={() => navigate('/contact')}>
                    Contact Us
                </button>
            </div>}
            {condition === true && <Policy showModal={handleSearch} onConfirm={handleConfirm} onClose={handleClose}/>}
            <div className='check'>
                <div className='check_text'>
                    <h6>Check For Sure</h6>
                    <p>For most people, buying a property is one of the biggest 
                        financial decisions of their life.</p>
                    <p>There are real risks involved -- you might end up purchasing a property 
                        with hidden issues, costing you thousands in unexpected repairs.</p>
                    <p>At Check For Sure, we offer access to a panel of independent, qualified 
                        inspectors to assist you with your property due diligence. Additionally, 
                        our unique cashback model ensures you don't waste money on properties 
                        that don't end up being the right fit for you.</p>
                    <div className='dummy_text'>
                        <img src={ok} alt='ok' />
                        <p>Mitigate risks of hidden property issues</p>
                    </div>
                    <div className='dummy_text'>
                        <img src={ok} alt='ok' />
                        <p>Access to trusted independent inspectors</p>
                    </div>
                    <div className='dummy_text'>
                        <img src={ok} alt='ok' />
                        <p>Save money with cashback guarantee</p>
                    </div>
                    <div className='dummy_text'>
                        <img src={ok} alt='ok' />
                        <p>Make confident, informed property decisions</p>
                    </div>
                </div>
                <div className='check_img'>
                    <div className='inner'>
                        <img src={inner} alt='inner' />
                    </div>
                    <div className='outer'>
                        <img src={outer} alt='outer' />
                    </div>
                </div>
            </div>
            <div className='mobile_search_result1'>
                <Findreport />
            </div>
        </div>
    );
};

export default Searchresult1;
